// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"59":"580fb240","83":"8b57d46e","233":"705794b3","270":"5e6524b3","660":"f3b8a700","774":"e535cbc7","842":"a0ec9c0e","999":"bbf61d25"}[chunkId] + ".chunk.js";
};